import { useCallback, useState } from "react"
import { useBanV1CmMutation } from "../../core/api/clockmaker-social-api"
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material"

const CmBanControl = ({ disabled, userId }) => {
    const [open, setOpen] = useState(false)
    const [reason, setReason] = useState("")

    const [ban, { isLoading }] = useBanV1CmMutation()

    const handleOpenDialog = useCallback(() => {
        setOpen(true)
    }, [setOpen])

    const handleCloseDialog = useCallback(() => {
        setOpen(false)
        setReason("")
    }, [setOpen, setReason])

    const handleChangeReason = useCallback((e) => {
        setReason(e?.target?.value ?? "")
    }, [setReason])

    const handleConfirm = useCallback(() => {
        ban({
            userId: userId,
            reason: reason.trim()
        })
        handleCloseDialog()
    }, [userId, reason, ban, handleCloseDialog])

    return (
        <>
            <Button
                fullWidth
                size="small"
                color="error"
                loading={isLoading}
                disabled={disabled}
                onClick={handleOpenDialog}
            >
                Ban on server
            </Button>
            <Dialog fullWidth maxWidth="sm" open={open} onClose={handleCloseDialog}>
                <DialogTitle>
                    Ban player '{userId}'
                </DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        fullWidth
                        multiline
                        rows={2}
                        margin="dense"
                        label="Reason"
                        value={reason}
                        onChange={handleChangeReason}
                    />
                </DialogContent>
                <DialogActions sx={{ justifyContent: "flex-end", alignItems: "center" }}>
                    <Button variant="contained" disabled={reason.trim() === ""} onClick={handleConfirm}>
                        Confirm
                    </Button>
                    <Button variant="outlined" onClick={handleCloseDialog}>
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default CmBanControl
